import { Observable } from 'rxjs';
var CustomPreloadingStrategy = /** @class */ (function () {
    function CustomPreloadingStrategy() {
    }
    CustomPreloadingStrategy.prototype.preload = function (route, fn) {
        if (route.data && route.data['nopreload']) {
            return Observable.of(false);
        }
        console.log('Will load the module rightaway');
        console.log(route);
        /*while(true) {
    
        }*/
        return Observable.of(true).delay(1).flatMap(function (_) { return fn(); });
        //return load();//.delay(1800).flatMap((_: boolean) => fn());
        //this.sub = Observable.interval(10000)
        //.subscribe((val) => { console.log('called'); });
    };
    return CustomPreloadingStrategy;
}());
export { CustomPreloadingStrategy };
//# sourceMappingURL=preload-after-usertypes.js.map